import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import KNB from '@dp/knb';
import Geo from 'drip/geo';
export default {
  name: 'search-bar',
  data: function data() {
    return {
      showCity: true,
      cityName: ''
    };
  },
  computed: {
    isMaoyanI: function isMaoyanI() {
      return ['qqwallet', 'maoyan_i', 'cmb_app'].includes(Drip.constant.uaInfo.appName);
    }
  },
  mounted: function mounted() {
    var _Drip$constant$cityNa = Drip.constant.cityName,
      cityName = _Drip$constant$cityNa === void 0 ? '' : _Drip$constant$cityNa;
    this.cityName = cityName;
    // 猫眼app中不展示定位
    this.showCity = Drip.constant.uaInfo.appName !== 'maoyan';
  },
  methods: {
    handleCityClick: function handleCityClick() {
      var _this = this;
      if (this.isMaoyanI && Drip.constant.isFromMtwxapp) {
        this.$router.push('/cities');
      } else if (this.isMaoyanI) {
        this.go('/cities');
      } else {
        KNB.pickCity({
          type: 0,
          // 默认值0:国内城市, 1: 国际城市;
          needResult: 0,
          // 默认值 0：选择且切换城市，1：支持选择城市但不切换 App 城市
          success: function success(result) {
            var cityName = result.cityName,
              cityId = result.cityId;
            if (!cityId) return;
            _this.cityName = cityName;
            Geo.setCity({
              cityId: cityId,
              cityName: cityName
            });
          }
        });
      }
      window.seedAction({
        bid: 'b_movie_cwyw3css_mc'
      });
    },
    handleSearchClick: function handleSearchClick() {
      window.lxTagReport('c_movie_aq5xt2v5', 'b_movie_twpdo6ou_mc');
      window.seedAction({
        bid: 'b_movie_twpdo6ou_mc'
      });
      this.go('/search', {
        _blank: true
      });
    }
  }
};